import PropTypes from "prop-types";


export default function MiscHeader(props) {


    return (
        <div>
            <h2 className="flex justify-center items-center bg-purple-950 pt-20 font-bold custom-font text-white" style={{height: "40vh"}}>
                {props.title || "Privacy Policy"}
            </h2>
        </div>
    )
}

MiscHeader.propTypes = {
    title: PropTypes.string,
}